import { Base } from '../base';
export const Empty = Base.define({
    shape: 'empty',
});
//# sourceMappingURL=empty.js.map